import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { Acuerdo } from '../acuerdo.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { EstadoAcuerdo } from '../estado-acuerdo.model';
import { Subcliente } from '../../cliente/subcliente.model';
import { SubclienteMonto } from '../../cliente/subclienteMonto.model';
import { NavigationService } from '../../shared-services/navigation.service';


@Component({
  selector: 'app-acuerdo-details',
  templateUrl: './acuerdo-details.component.html',
  styleUrls: ['./acuerdo-details.component.scss']
})
export class AcuerdoDetailsComponent implements OnInit {
  acuerdo: Acuerdo;
  EstadoAcuerdo = new EstadoAcuerdo();
  subclientes: Subcliente[] = [];
  subclientesMonto: SubclienteMonto[] = [];

  totalItems: any;
  isLoading: any;

  onPageChange(any) {}

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService,
    private navigationService: NavigationService
  ) { }

  async ngOnInit() {
    this.route.data.subscribe(data => {
      this.acuerdo = data.acuerdo;
    });
    await this.getCantidadComprada();

    await this.getMontosSubclientes();

  }

  editar(id: number) {
    this.router.navigate(['/acuerdos/editar', id]);
  }

  async confirmEliminar() {
    this.dialogService.confirm('Eliminar Acuerdo',
    '¿Está seguro que desea eliminar el Acuerdo ' + this.acuerdo.numero + '?')
    .then( res => {
      if (res) {
        this.deleteAcuerdo(res);
      }
    });
  }
  async deleteAcuerdo(res) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Acuerdo.path + this.acuerdo.id);
        this.snackService.success('Acuerdo eliminado correctamente');
        this.router.navigate([Acuerdo.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

  async confirmRehabilitar() {
    this.dialogService.confirm('Rehabilitar Acuerdo',
    '¿Está seguro que desea rehabilitar el Acuerdo ' + this.acuerdo.numero + '?')
    .then( res => {
      if (res) {
        this.rehabilitar(res);
      }
    });
  }
  async rehabilitar(res) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Acuerdo.path + 'rehabilitar', {id : this.acuerdo.id} );
        this.snackService.success('Acuerdo rehabilitado correctamente');
        this.router.navigate([Acuerdo.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }


  async getMontosSubclientes() {
    // tslint:disable-next-line:max-line-length
    await this.backendService.get(SubclienteMonto, Subcliente.path + 'allByAcuerdo/' + this.acuerdo.id, null).toPromise().then(value => {
       this.subclientesMonto = value as SubclienteMonto[];
    });
  }

  onEditMontoMax(id) {
    this.router.navigate(['/acuerdos/' + id + '/monto-max-usuarios']);
  }

  async getCantidadComprada() {
    for (let i = 0; i < this.acuerdo.productos.length; i++) {
      await this.backendService.getBoolean(Acuerdo.path + 'cant-total-prod/' + this.acuerdo.id
                  + '/' + this.acuerdo.productos[i].producto.id).then(
        value => {
          this.acuerdo.productos[i].cantidadComprada = value.cantidad;
          this.acuerdo.productos[i].total = value.total;
        });
    }
  }

  pedidos(id: number) {
    this.router.navigate(['/productos/pedidos', id]);
  }

  back() {
    this.navigationService.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-details/acuerdo-details.component.ts